<div class="layout-guest-sign-root" [class.layout-guest-sign-root--with-bg]="isCustomerLayout">
    <div class="layout-guest-sign-bg" *ngIf="isCustomerLayout" aria-hidden="true"
    [style.backgroundImage]="backgroundStyle"></div>
    <div class="layout-guest-sign-content">
        <kzn-header-before-login></kzn-header-before-login>
        <main class="sign-main" [ngClass]="{ 'layout__customer': isCustomerLayout, 'sign-main--pdf': isPdfViewerRoute }">
            <div class="sign-main-inner" [class.sign-main-inner--pdf]="isPdfViewerRoute">
                <router-outlet></router-outlet>
            </div>
        </main>
        <kzn-footer></kzn-footer>
    </div>
</div>